import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { IAM_TENANT_SLUG } from "@/core/config";

const LEGACY_DEMO_SLUG = "demo-hospitol";
const MIGRATION_MARKER_PREFIX = "hospitol.storage.migrated@";

/** Slug tenant actif (session IAM ou fallback dev). */
export function getActiveTenantSlug(): string {
  const slug =
    loadStoredSession()?.tenant?.slug?.trim().toLowerCase() ??
    IAM_TENANT_SLUG.trim().toLowerCase();
  return slug || LEGACY_DEMO_SLUG;
}

export function tenantStorageKey(baseKey: string): string {
  return `${baseKey}@${getActiveTenantSlug()}`;
}

function migrationMarkerKey(baseKey: string): string {
  return `${MIGRATION_MARKER_PREFIX}${getActiveTenantSlug()}:${baseKey}`;
}

/** Migre une seule fois les clés globales legacy vers demo-hospitol (compat démo existante). */
function migrateLegacyKeyIfNeeded(baseKey: string): void {
  const scoped = tenantStorageKey(baseKey);
  if (localStorage.getItem(scoped) !== null) return;

  const marker = migrationMarkerKey(baseKey);
  if (localStorage.getItem(marker)) return;

  if (getActiveTenantSlug() === LEGACY_DEMO_SLUG) {
    const legacy = localStorage.getItem(baseKey);
    if (legacy !== null) {
      localStorage.setItem(scoped, legacy);
    }
  }
  localStorage.setItem(marker, "1");
}

export function getTenantStorageItem(baseKey: string): string | null {
  migrateLegacyKeyIfNeeded(baseKey);
  return localStorage.getItem(tenantStorageKey(baseKey));
}

export function setTenantStorageItem(baseKey: string, value: string): void {
  localStorage.setItem(tenantStorageKey(baseKey), value);
}

export function removeTenantStorageItem(baseKey: string): void {
  localStorage.removeItem(tenantStorageKey(baseKey));
}

export function readTenantJson<T>(baseKey: string, fallback: T): T {
  migrateLegacyKeyIfNeeded(baseKey);
  try {
    const raw = localStorage.getItem(tenantStorageKey(baseKey));
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeTenantJson(baseKey: string, value: unknown): void {
  setTenantStorageItem(baseKey, JSON.stringify(value));
}
